import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ie-robot",
  "use": "icon-ie-robot-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ie-robot\">\r\n    <path d=\"M406.9376 88.55552a122.88 122.88 0 0 1 173.79328 0l317.72672 317.76768a122.88 122.88 0 0 1 0 173.75232l-317.72672 317.76768a122.88 122.88 0 0 1-173.79328 0l-317.72672-317.76768a122.88 122.88 0 0 1 0-173.75232l317.72672-317.76768z\" fill=\"#36CFC9\" p-id=\"19909\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol